import { lazy, Suspense } from 'react'
import PageMeta from 'src/_shared/components/PageMeta'
import Hero from 'src/pages/Media/components/Hero'

const CallToActionSection = lazy(() => import('src/_shared/components/CallToActionSection'))
const NewsRoom = lazy(() => import('src/pages/Media/components/NewsRoom'))

export const Media = (): JSX.Element => {
	return (
		<div>
			<PageMeta
				title="Voltality News and Media"
				description="Stay up-to-date with the latest news, press releases, and media coverage from Voltality, a leader in EV charging and eRoaming."
			/>
			<Hero />
			<Suspense fallback={<></>}>
				<NewsRoom />
				<CallToActionSection />
			</Suspense>
		</div>
	)
}
